import RequestedPackageListPage from "./pages/RequestedPackageListPage";
import RequestedPackageDetailPage from "./pages/RequestedPackageDetailPage";

export const requestedPackageRoutes = (prefix = "requested-packages") => [
  {
    name: "RequestedPackageDetailPage",
    path: `${prefix}/:id`,
    component: RequestedPackageDetailPage
  },
  {
    name: "RequestedPackageListPage",
    path: prefix,
    component: RequestedPackageListPage
  }
];
